module.exports = __webpack_public_path__ + "static/media/yfx.f7d81d32.svg";